export default "__VITE_ASSET__Dgi58TNB__"